<template>
  <div
      :class="[b(),className]"
      :style="styleSizeName"
  >
    <div
        :ref="id"
        :style="styleChartName"
    >
      <div
          class="gran"
          :style="{
            color: fontColor,
            'font-size': fontSize + 'px',
            '--btn-bg-color': defaultColor,
            '--btn-ac-color': activeColor,
            '--btn-sel-color': btnSelColor,
            '--btn-start-color': startColor,
            '--btn-end-color': endColor,
            '--btn-border-color': borderColor,
      }"
      >
        <template v-if="!option.range">
          <span
              :class="[
          'year-type cursor',
          activeIndex === 'current' ? 'active' : '',
        ]"
              @click="handleTypeChange('current')"
          >
          {{ currentUnit }}
        </span>
          <span
              :class="[
          'year-type cursor',
          activeIndex === 'last' ? 'active' : '',
        ]"
              @click="handleTypeChange('last')"
          >
          {{ lastUnit }}
        </span>
        </template>
        <el-date-picker range-separator="至" class="year-date-select date-wrapper-cus" v-model="timeValue" :type="unit"
                        size="small"
                        placeholder="请选择" popper-class="select-popper big-year-popper">
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const CURRENT_RANGE_MAP = {
  'year': 'yearrange',
  'month': 'monthrange',
  'days': 'daterange'
}
const CURRENT_MAP = {
  'year': '今年',
  'month': '本月',
  'days': '今日'
}
const LAST_MAP = {
  'year': '去年',
  'month': '上月',
  'days': '昨日'
}

const FORMAT_MAP = {
  'year': 'yyyy',
  'month': 'yyyy-MM',
  'days': 'yyyy-MM-DD'
}

export default {
  name: "year",
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      options: [],
      timeValue: "2023",
      activeIndex: "current",
      borderRadius: "0px",
      fontColor: "",
      timeUnit: 'year',
      defaultColor: "#0042a554",
      activeColor: "#0A9C8B",
      btnSelColor: '#40B9FF',
      startColor: "#1199dc",
      endColor: "#0d73bc00",
      borderColor: '#0080ff',
      currentValue: '',
      lastValue: ''
    };
  },
  computed: {
    unit() {
      if (this.option.range) {
        return CURRENT_RANGE_MAP[this.timeUnit]
      }
      return this.timeUnit
    },
    currentUnit() {
      return CURRENT_MAP[this.timeUnit]
    },
    lastUnit() {
      return LAST_MAP[this.timeUnit]
    },
    fontSize() {
      return this.option.labelShowFontSize || 14
    }
  },
  watch: {
    timeValue(val) {
      this.handleValueChange(val);
    },
  },
  created() {
    if (this.option.range) {
      this.timeValue = []
    }
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    handleTypeChange(type) {
      this.activeIndex = type;
      if (type === "current") {
        this.timeValue = `${moment().subtract(0, this.timeUnit)}`
      } else if (type === "last") {
        this.timeValue = `${moment().subtract(1, this.timeUnit)}`
      }
    },
    handleValueChange(timeValue) {
      let formatVal
      if (this.option.range) {
        formatVal = [moment(timeValue[0]).format(FORMAT_MAP[this.timeUnit]), moment(timeValue[1]).format(FORMAT_MAP[this.timeUnit])]
      } else {
        formatVal = moment(timeValue).format(FORMAT_MAP[this.timeUnit])
        if (formatVal == this.currentValue) {
          this.activeIndex = "current";
        } else if (formatVal == this.lastValue) {
          this.activeIndex = "last";
        } else {
          this.activeIndex = "";
        }
      }

      this.setLinkData(this.dcode, formatVal)
    },
    getRecentThreeMonth() {
      const monthStart = moment().subtract(3, 'months');
      const monthEnd = moment();

      // 获取时间戳（以毫秒为单位）
      const startTimestamp = monthStart.valueOf();
      const endTimestamp = monthEnd.valueOf();
      return [
        startTimestamp,
        endTimestamp
      ]
    },
    updateChart() {
      const {
        timeUnit = 'year',
        labelShowColor,
        barColor = [],
      } = this.option
      console.log('this.option>>>', this.option)
      this.fontColor = labelShowColor || '#ffffff'
      this.startColor = barColor[0]?.color1 || '#1199dc'
      this.endColor = barColor[0]?.color2 || '#0d73bc00'
      this.borderColor = barColor[1]?.color1 || '#0080ff'
      if (labelShowColor) {
        this.btnSelColor = labelShowColor;
      }
      this.timeUnit = timeUnit
      if (this.option.range) {
        this.timeValue = this.getRecentThreeMonth()
      } else {
        this.currentValue = moment(`${moment().subtract(0, this.timeUnit)}`).format(FORMAT_MAP[this.timeUnit])
        this.lastValue = moment(`${moment().subtract(1, this.timeUnit)}`).format(FORMAT_MAP[this.timeUnit])
        if (this.option.defaultValue) {
          this.timeValue = this.option.defaultValue
        } else {
          this.timeValue = `${moment().subtract(0, this.timeUnit)}`
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-class {
  height: 100%;
  padding: 10px;
}

.gran {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .mr-8 {
    margin-right: 8px;
  }

  .cursor {
    cursor: pointer;
  }

  .year-type {
    background: none;
    width: 52px;
    height: 20px;
    display: block;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16.47px;
    opacity: 0.8;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: "PingFang SC";

    &.active {
      color: var(--btn-sel-color);
      border-top: 1px solid var(--btn-border-color);
      background: linear-gradient(180deg, var(--btn-start-color) 0%, var(--btn-end-color) 100%);
    }
  }

  :deep(.el-input__inner) {
    background: none !important;
    border: none;
    padding: 0;
    color: var(--btn-ac-color);
    line-height: 20px;
    height: 20px;
  }

  :deep(.el-icon) {
    color: var(--btn-sel-color);
  }

  :deep(.el-select__caret) {
    font-size: 12px;
    width: 16px;
    line-height: 20px;
    color: var(--btn-ac-color);
  }
}
</style>

<style>
.select-popper.el-popper.is-pure {
  background: radial-gradient(88.85% 68.47% at 50% 0%, #95ecff80 0%, #00a3ff40 24.48%, #0066ff26 61.98%, #0047ff00 100%), linear-gradient(180deg, #7cd0ff66 0%, #0047ff66 100%), #002b5c80;
  stroke-width: 0.96px;
  stroke: #00A3FF;
}

.select-popper .el-picker-panel {
  background-color: transparent;
}

.select-popper.el-popper.is-light .el-popper__arrow:before {
  background-color: transparent;
  border: transparent
}

.select-popper .el-date-picker__header-label {
  color: #ffffff;
  opacity: 0.8;
  font-size: 14px;
}

.select-popper .el-picker-panel__content .available .cell {
  color: #ffffff;
  opacity: 0.8;
}

.select-popper .el-picker-panel__content .current.available .cell {
  color: #01DBE3;
  opacity: 0.8;
}

.select-popper .el-picker-panel__content .available.today .cell {
  color: #01DBE3;
  opacity: 0.8;
}

.select-popper .el-picker-panel__icon-btn {
  color: #ffffff;
  opacity: 0.8;
}

div.year-date-select.el-date-editor.el-input,
.el-date-editor.el-input__wrapper {
  width: 150px;
}

div.year-sel {
  background: rgba(10, 125, 190, 0.7);
  color: #00eaff;
  border: 1px solid #01c2ff;
  border-radius: 4px;
}

div.year-sel .popper__arrow {
  display: none;
}

div.year-sel .el-select-dropdown__item {
  padding: 3px 14px;
  text-align: center;
  color: #00eaff;
  background: none !important;
}

div.year-sel .el-select-dropdown__item.selected,
div.year-sel .el-select-dropdown__item.hover {
  background: none !important;
  color: #00eaff;
}

div.year .el-input__wrapper {
  background: none !important;
  box-shadow: none !important;
}

.date-wrapper-cus {
  position: relative;
  top: -1px;
}
</style>
